import { render, staticRenderFns } from "./fccCorrecaoCadastral.vue?vue&type=template&id=7c23225e"
import script from "./fccCorrecaoCadastral.vue?vue&type=script&lang=js"
export * from "./fccCorrecaoCadastral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports